/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Fulfillment_Waiting_On_AcknowledgementInputs */

const en_fulfillment_waiting_on_acknowledgement = /** @type {(inputs: Fulfillment_Waiting_On_AcknowledgementInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on the warehouse · to take the instruction · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on the warehouse · to take the instruction · since {since}" |
*
* @param {Fulfillment_Waiting_On_AcknowledgementInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_waiting_on_acknowledgement = /** @type {((inputs: Fulfillment_Waiting_On_AcknowledgementInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Waiting_On_AcknowledgementInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_waiting_on_acknowledgement(inputs)
});